<template>
  <div class="disqus-panel">
    <template v-if="!isCommentEnabled">
      <alert-box level="warning" class="disqus-panel__warning">
        Comments are disabled at the moment.
      </alert-box>
    </template>
    <template v-else>
      <div class="disqus-panel__title" v-if="showTitle">
        Comments <span v-if="total">({{ total.toLocaleString() }} Archived)</span>
      </div>
      <div class="disqus-panel__content">
        <div v-if="currentTitle" class="disqus-panel__subtitle">
          {{ currentTitle }}
        </div>
        <p class="disqus-panel__note">
          <strong>DISCLAIMER:</strong>
          The Disqus comment section below is for informational purposes only.
          <a @click.prevent.stop="showExplanation = !showExplanation" class="disqus-panel__link"
            >What does this mean?</a
          >
          <transition name="disqus-panel">
            <div v-if="showExplanation">
              <brand-name></brand-name> does not monitor or assess the accuracy of comments. Traders
              should seek out independent information before making any investment decision.
              <brand-name></brand-name> removes comments and may ban users that violate the terms of
              service (such as those containing inappropriate or offensive language or content) if
              we become aware of them. See also the
              <a
                href="https://help.disqus.com/en/articles/1717116-basic-rules-for-disqus"
                v-outer-link
                >Basic Rules for Disqus</a
              >
              and
              <a href="https://help.disqus.com/en/articles/1717227-how-to-report-abuse" v-outer-link
                >How to Report Abuse on Disqus</a
              >.
            </div>
          </transition>
        </p>
        <div class="disqus" id="disqus_thread"></div>
        <div v-if="previousThread !== null || nextThread !== null">
          <p class="disqus-panel__note">
            <strong>ARCHIVED COMMENTS:</strong>
            Every so often we need to archive the comments on a page. If that happens we still make
            the archived comments accessible by clicking the Older Comments link.
          </p>
          <div class="disqus-panel__navigation">
            <div
              v-if="previousThread !== null"
              @click="onPrevious"
              class="disqus-panel__navigation-link disqus-panel__navigation-link--left"
            >
              < OLDER COMMENTS
            </div>
            <div
              v-if="nextThread !== null"
              @click="onNext"
              class="disqus-panel__navigation-link disqus-panel__navigation-link--right"
            >
              NEWER COMMENTS >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script src="./disqus.js"></script>
<style src="./disqus.scss" lang="scss"></style>
